// import dayjs from 'dayjs'

export const tableDataSchemas = [
  {
    prop: 'tenantId',
    label: '租户id',
    minWidth: 80
  },
  {
    prop: 'clinicId',
    label: '诊所id',
    minWidth: 80
  },
  {
    prop: 'name',
    label: '诊所/医院名',
    minWidth: 200
  },
  // {
  //   prop: 'description',
  //   label: '诊所描述',
  //   minWidth: 180
  // },
  {
    prop: 'expireDate',
    label: 'applink服务过期时间',
    minWidth: 150
  },
  {
    prop: 'section',
    label: '诊所域',
    minWidth: 150
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150
  }
]

// const validateExpireDate = (rule, value, callback) => {
//   console.log(value)

//   const today = new Date()
//   today.setHours(0, 0, 0, 0)

//   const start = new Date(value)

//   if (+dayjs(today) - +dayjs(start) > 0) {
//     callback(new Error('开始时间不能早于当前时间'))
//   } else {
//     callback()
//   }
// }

export const formRule = {
  username: [{ required: true, message: 'appLink账号未填写', trigger: 'blur' }],
  password: [{ required: true, message: 'appLink密码未填写', trigger: 'blur' }],
  name: [{ required: true, message: '医院/诊所未填写', trigger: 'blur' }],
  expireDate: [
    { required: true, message: '过期时间未选择', trigger: 'change' }
    // { validator: validateExpireDate, trigger: 'change' }
  ],
  mobile: [
    {
      pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
      message: '手机号格式不正确',
      trigger: 'blur'
    }
  ],
  telephone: [
    {
      pattern: /0\d{2,3}-\d{7,8}/,
      message: '手机号格式不正确',
      trigger: 'blur'
    }
  ],
  email: [
    {
      pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
      message: '邮箱格式不正确',
      trigger: 'blur'
    }
  ]
}

export const typeList = [
  {
    label: '全诊通',
    value: '1'
  }
]
